import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { WORKFLOW_ACTIONS } from '../../../../component-loader/action-definitions';

@Component({
  selector: 'automata-no-user-input-panel',
  template: `
    <div class="content" *ngIf="description">
      <div class="description subtitle">{{ description | translate }}</div>
    </div>
  `,
  styleUrls: ['./no-user-input-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, GalaxyAlertModule],
})
export class NoUserInputPanelComponent extends CommonActionPanelComponent implements OnInit {
  description: string | undefined = '';
  ngOnInit(): void {
    super.ngOnInit();
    this.description = WORKFLOW_ACTIONS[this.taskDefinitionId]?.panelDescription;
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    return {};
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
